export function translateErrors(message: string) {
  if (message.length === 0) {
    return null;
  }

  if (
    message.includes("must be shorter than or equal to 11 characters") ||
    message.includes("must be longer than or equal to 9 characters")
  ) {
    return "O renavan deve conter entre 9 e 11 dígitos";
  }
  if (message.includes("Vehicle not found")) {
    return "Renavan do veículo não encontrado";
  }
  if (message.includes("Invalid recaptcha token")) {
    return "Erro ao buscar débitos, tente novamente!";
  }
  if (message.includes("The field license_plate is required.")) {
    return "A placa do veículo é obrigatória.";
  }
  if (message.includes("The field document is required.")) {
    return "O documento é obrigatório.";
  }
  if (message.includes("The field renavam is required.")) {
    return "O renavam do veículo é obrigatório.";
  }

  return `Erro: ${message} `;
}
